<template>
    <v-container fluid class="pa-4" style="height: inherit; background-color: white;">

        <h3 class="mb-3">{{ $t('servicesystem.common_objects.export.transactions') }}</h3>

        <template v-if="loading">
            <v-progress-linear :indeterminate="loading" color="primary" style="width: 410px;">
            </v-progress-linear>
        </template>

        <template v-else-if="!loading && (files.length > 0 || history.length > 0)">
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th style="width: 40px"></th>
                            <th class="text-left">{{ $t('servicesystem.common_objects.export.col1') }}</th>
                            <th class="text-left">{{ $t('servicesystem.common_objects.commonterms.date') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="file in files" :key="'file-' + file.FilePath">
                            <td>
                                <v-icon small :color="fileIcon(file.Name).color">{{ fileIcon(file.FileName).icon
                                }}</v-icon>
                            </td>
                            <td><a :href="`/api2/resource/?relativePath=${encodeURI(file.FilePath)}`">{{ file.Name
                            }}</a></td>
                            <td>{{ formatDate(file.TimeStamp) }}</td>
                            <td>
                                <v-btn small text color="primary" @click="markCompleted(file)">
                                    Mark Completed
                                </v-btn>
                            </td>
                        </tr>
                        <tr v-if="history.length > 0">
                            <td colspan="4" class="pa-0">
                                <div class="text-caption grey--text my-2 ml-2">
                                    {{ $t('servicesystem.common_objects.export.recentexports') }}
                                </div>
                            </td>
                        </tr>
                        <tr v-for="file in history" :key="'history-' + file.FilePath" class="grey--text">
                            <td>
                                <v-icon small color="grey">mdi-delete</v-icon>
                            </td>
                            <td>{{ file.Name }}</td>
                            <td>{{ formatDate(file.TimeStamp) }}</td>
                            <td>
                                <v-btn small text color="primary" @click="restore(file)">
                                    <v-icon small left>mdi-restore</v-icon>
                                    Restore
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </template>

        <template v-else>
            {{ $t('servicesystem.common_objects.export.no_files') }}
        </template>
    </v-container>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';

export default {
    name: 'ExportModern',
    components: {},
    mixins: [ClientAPIMixin],

    data() {
        return {
            files: [],
            history: [],
            loading: false,
        };
    },

    mounted() {
        if (this.userAllowedImportExport) {
            this.getData();
        }
    },

    methods: {
        getData() {
            this.loading = true;
            this.getExportModern()
                .then((response) => {
                    this.files = response.Files;
                    this.history = response.History;
                    this.loading = false;
                });
        },

        fileIcon(fileName) {
            const ext = (fileName || '').split('.').pop().toLowerCase();
            if (ext === 'xml') return { icon: 'mdi-file-xml-box', color: 'orange' };
            if (ext === 'xlsx') return { icon: 'mdi-file-excel', color: 'green' };
            return { icon: 'mdi-file-question-outline', color: 'grey' };
        },

        formatDate(dateString) {
            if (!dateString) return '';
            return new Date(dateString).toLocaleString();
        },

        markCompleted(file) {
            this.clearTransaction(file.ExportDate, file.FileName)
                .then(() => {
                    this.getData();
                });
        },

        restore(file) {
            this.restoreTransaction(file.FileName)
                .then(() => {
                    this.getData();
                });
        },
    },
};
</script>


<style lang='scss' scoped></style>
